export const ApiAddress = "https://miniapp.farazbit.com";